import { render } from "./accountDetail.vue?vue&type=template&id=1b70529c&scoped=true&ts=true"
import script from "./accountDetail.vue?vue&type=script&lang=ts"
export * from "./accountDetail.vue?vue&type=script&lang=ts"

import "./accountDetail.vue?vue&type=style&index=0&id=1b70529c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b70529c"],['__file',"src/components/account/accountDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b70529c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b70529c', __exports__)) {
    api.reload('1b70529c', __exports__)
  }
  
  module.hot.accept("./accountDetail.vue?vue&type=template&id=1b70529c&scoped=true&ts=true", () => {
    api.rerender('1b70529c', render)
  })

}


export default __exports__